import React, { useState, useEffect } from 'react'
import { fadeIn} from 'react-animations'
import styled, { keyframes } from 'styled-components';

const Behaviours = (props) => {
    const a1 = keyframes`${fadeIn}`;
    const AnimateContent = styled.div`animation: 2s ${a1};`;

    const [rows, setRows] = useState(props.rows);

  return (
    <div className="behaviours">
        <p>Decades of research encompassing thousands of leaders within various industries have enabled a model of eﬀective  leadership behaviours. The research captured the actions which are highly correlated with superior organizational performance and  leadership success. These are summarized in the High-Performance Behaviour model (HPB) for leaders. The HPB model  comprises of 12 behaviours forming four behavioural clusters, providing a rich and in-depth understanding of  leadership.</p>
        <AnimateContent>
        <div className="beahviors row">
            { rows.length > 0 && rows.map((item,index)=>{
                return <div key={index} className="col-lg-3 col-md-6 col-sm-6">
                    <div className="cluster-card" style={{backgroundColor: item.Color}}>
                        <h6 className="header">{item.Name}</h6>
                        <hr/>
                        <div className="body">
                        {
                            item.Behaviours.map((b,bi)=>{
                                return (
                                    <span key={bi}>{b.Name}</span>
                                )
                            })
                        }
                        <hr/>
                        </div>
                    </div>
                    <br/>
                </div>
            })}
        </div>
        </AnimateContent>
    </div>
  )
}

export default Behaviours